const hi = {
	nav: {
		home: 'होम',
		california: 'कैलिफ़ोर्निया',
		texas: 'टेक्सास',
		florida: 'फ़्लोरिडा',
		menu: 'मेन्यू',
		faq: 'सामान्य प्रश्न',
		freeEstimate: 'निःशुल्क अनुमान',
		bookNow: 'अभी बुक करें',
		myBooking: 'मेरी बुकिंग',
	},
	seo: {
		homeDescription: 'शीर्ष रेटेड होम हिबाची अनुभव। हम कैलिफ़ोर्निया, टेक्सास और फ़्लोरिडा में आपके घर पर हिबाची ग्रिल + शेफ लाते हैं।',
	},
	hero: {
		title: 'HAPPY HIBACHI',
		tagline: '#1 रेटेड होम हिबाची',
		subtitle: 'अपने घर पर प्रामाणिक जापानी हिबाची खाना पकाने का अनुभव करें',
		description: 'पेशेवर शेफ हिबाची-स्टाइल खाना पकाने का उत्साह सीधे आपके आंगन में लाते हैं।',
		bookNow: 'अभी बुक करें',
		freeEstimate: 'निःशुल्क अनुमान',
	},
	howItWorks: {
		title: 'यह कैसे काम करता है',
		subtitle: 'आपकी परफेक्ट हिबाची पार्टी के लिए सरल कदम',
		step1: { title: 'ऑनलाइन बुक करें', description: 'अपनी तारीख, समय और मेन्यू चुनें' },
		step2: { title: 'हम तैयार करते हैं', description: 'हमारी टीम सभी सामग्री और उपकरण संभालती है' },
		step3: { title: 'शो का आनंद लें', description: 'हमारे शेफ को प्रदर्शन करते देखें और स्वादिष्ट भोजन का आनंद लें' },
		step4: { title: 'हम साफ करते हैं', description: 'आराम करें जब हम सफाई संभालते हैं' },
	},
	menu: {
		title: 'मूल्य निर्धारण और सेवा',
		subtitle: 'ताज़ी सामग्री, प्रामाणिक स्वाद',
		proteins: 'प्रोटीन',
		sides: 'साइड डिश और एपेटाइज़र',
		chicken: 'चिकन',
		steak: 'फ़िलेट मिग्नॉन',
		shrimp: 'झींगा',
		salmon: 'सैल्मन',
		lobster: 'लॉबस्टर टेल',
		tofu: 'टोफू (शाकाहारी)',
		friedRice: 'हिबाची फ्राइड राइस',
		noodles: 'याकिसोबा नूडल्स',
		vegetables: 'ग्रिल्ड सब्ज़ियां',
		salad: 'अदरक सलाद',
		soup: 'मिसो सूप',
		edamame: 'एडामामे',
		includes: {
			salad: 'ताज़ा सलाद',
			rice: 'फ्राइड राइस',
			vegetables: 'हिबाची सब्ज़ियां',
			show: 'गेम और शो',
		},
		protein: {
			title: 'प्रोटीन विकल्प',
			included: 'शामिल है',
		},
		upgrades: {
			title: 'प्रीमियम अपग्रेड',
			filet: 'फ़िलेट मिग्नॉन',
			lobster: 'लॉबस्टर',
			ribeye: 'प्रीमियम रिबआई',
			shrimp: 'जंबो झींगा',
			salmon: 'वाइल्ड सैल्मन',
			scallops: 'बड़े स्कैलप्स',
		},
		addons: {
			title: 'ऐड-ऑन',
			gyoza: 'ग्योज़ा (12 पीस)',
			edamame: 'एडामामे',
			noodles: 'नूडल्स',
			thirdProtein: 'तीसरा प्रोटीन',
		},
		coupon: {
			title: 'विशेष कूपन',
			subtitle: 'केवल रविवार से शुक्रवार की पार्टियों के लिए!',
			email: 'हमें ईमेल करें',
		},
		note: {
			outdoor: 'हम केवल बाहर खाना बनाते हैं।',
			weather: 'हम बारिश या धूप में सेवा प्रदान करते हैं, जब तक शेफ के लिए खाना बनाने के लिए सूखी जगह हो।',
		},
	},
	pricing: {
		title: 'मूल्य निर्धारण',
		subtitle: 'पारदर्शी मूल्य निर्धारण बिना छिपी फीस के',
		perPerson: 'प्रति व्यक्ति',
		minimum: 'सभी पार्टियों के लिए न्यूनतम',
		kids: 'प्रति बच्चा 12 और उससे कम',
		includes: 'शामिल है',
		includesList: {
			chef: 'पेशेवर हिबाची शेफ',
			ingredients: 'सभी सामग्री और आपूर्ति',
			equipment: 'हिबाची ग्रिल और उपकरण',
			setup: 'सेटअप और सफाई',
			show: 'लाइव कुकिंग एंटरटेनमेंट',
		},
		basic: { title: 'बेसिक पैकेज', description: 'छोटे समारोहों के लिए परफेक्ट' },
		premium: { title: 'प्रीमियम पैकेज', description: 'संपूर्ण हिबाची अनुभव' },
		deluxe: { title: 'डीलक्स पैकेज', description: 'अल्टीमेट लक्ज़री डाइनिंग' },
	},
	calendar: {
		available: 'उपलब्ध',
		limited: 'सीमित',
		busy: 'व्यस्त',
		unavailable: 'अनुपलब्ध',
		today: 'आज',
		prevMonth: 'पिछला महीना',
		nextMonth: 'अगला महीना',
		weekdays: {
			sun: 'रवि',
			mon: 'सोम',
			tue: 'मंगल',
			wed: 'बुध',
			thu: 'गुरु',
			fri: 'शुक्र',
			sat: 'शनि',
		},
		months: {
			january: 'जनवरी',
			february: 'फरवरी',
			march: 'मार्च',
			april: 'अप्रैल',
			may: 'मई',
			june: 'जून',
			july: 'जुलाई',
			august: 'अगस्त',
			september: 'सितंबर',
			october: 'अक्टूबर',
			november: 'नवंबर',
			december: 'दिसंबर',
		},
	},
	slider: {
		chef: 'एक्शन में पेशेवर हिबाची शेफ',
		steak: 'स्वादिष्ट हिबाची स्टेक',
		shrimp: 'अद्भुत हिबाची झींगा',
		setup: 'प्रीमियम हिबाची सेटअप',
		presentation: 'सुंदर फूड प्रेज़ेंटेशन',
	},
	booking: {
		title: 'अपना इवेंट बुक करें',
		subtitle: 'शुरू करने के लिए अपना क्षेत्र चुनें',
		selectRegion: 'शुरू करने के लिए अपना क्षेत्र चुनें',
		california: 'कैलिफ़ोर्निया',
		texas: 'टेक्सास',
		florida: 'फ़्लोरिडा',
		californiaTagline: 'आपके दरवाज़े पर पेशेवर हिबाची',
		texasTagline: 'टेक्सास में हिबाची उत्कृष्टता लाना',
		floridaTagline: 'सनशाइन स्टेट हिबाची अनुभव',
		servingAreas: 'हम जिन क्षेत्रों में सेवा देते हैं',
		bookIn: 'अभी बुक करें',
		note: '* कोई भुगतान आवश्यक नहीं। हम पुष्टि के लिए आपसे संपर्क करेंगे।',
		quickBook: 'त्वरित बुकिंग:',
		summary: 'बुकिंग विवरण',
		addToCalendar: 'कैलेंडर में जोड़ें',
	},
	gallery: {
		title: 'गैलरी',
		subtitle: 'Happy Hibachi का अंतर अनुभव करें',
		items: {
			chef: 'पेशेवर हिबाची शेफ',
			chefDesc: 'एक्शन में पेशेवर हिबाची शेफ',
			grill: 'हिबाची ग्रिल सेटअप',
			grillDesc: 'प्रीमियम हिबाची ग्रिल सेटअप',
			steak: 'हिबाची स्टेक',
			steakDesc: 'स्वादिष्ट हिबाची स्टेक',
			vegetables: 'हिबाची सब्ज़ियां',
			vegetablesDesc: 'ताज़ी हिबाची सब्ज़ियां',
			shrimp: 'हिबाची झींगा',
			shrimpDesc: 'अद्भुत हिबाची झींगा',
			food: 'फूड प्रेज़ेंटेशन',
			foodDesc: 'सुंदर फूड प्रेज़ेंटेशन',
		},
	},
	calculator: {
		title: 'मूल्य कैलकुलेटर',
		subtitle: 'अपने इवेंट के लिए तुरंत अनुमान प्राप्त करें',
		guests: 'मेहमानों की संख्या',
		adults: 'वयस्क',
		kids: 'बच्चे (10 और कम)',
		upgrades: 'वैकल्पिक अपग्रेड',
		summary: 'मूल्य सारांश',
		subtotal: 'उप-योग',
		discount: 'समूह छूट',
		minimum: 'न्यूनतम ऑर्डर',
		total: 'कुल',
		gratuity: 'सुझाई गई टिप',
		grandTotal: 'महायोग',
		bookNow: 'अपना इवेंट बुक करें',
		note: '* स्थान के आधार पर यात्रा शुल्क लागू हो सकता है। बुकिंग पर अंतिम मूल्य की पुष्टि।',
		minimumNotice: 'न्यूनतम 10 मेहमान आवश्यक',
		thirdProtein: 'तीसरा प्रोटीन',
		noodles: 'नूडल्स',
	},
	reviews: {
		title: 'ग्राहक समीक्षाएं',
		subtitle: 'देखें हमारे ग्राहक अपने Happy Hibachi अनुभव के बारे में क्या कह रहे हैं',
		bookNow: 'अपना इवेंट बुक करें',
		ctaTitle: 'अपना अद्भुत अनुभव बनाने के लिए तैयार हैं?',
		ctaText: 'सैकड़ों संतुष्ट ग्राहकों से जुड़ें',
		rating: '5.0 औसत रेटिंग',
		verified: '100+ सत्यापित समीक्षाएं',
		topRated: 'शीर्ष रेटेड सेवा',
	},
	instagram: {
		title: 'हमारी यात्रा फॉलो करें',
		followUs: 'इंस्टाग्राम पर हमें फॉलो करें',
	},
	referral: {
		title: 'दोस्तों को रेफर करें, इनाम पाएं',
		subtitle: 'हिबाची प्यार साझा करें और इनाम पाएं!',
		step1Title: 'अपना कोड शेयर करें',
		step1Desc: 'अपना यूनिक रेफरल कोड दोस्तों और परिवार के साथ शेयर करें',
		step2Title: 'दोस्त बुक करता है',
		step2Desc: 'आपके दोस्त को पहली बुकिंग पर $30 की छूट मिलती है',
		step3Title: 'आपको इनाम मिलता है',
		step3Desc: 'अपने अगले इवेंट के लिए $50 क्रेडिट पाएं',
		yourReward: 'आपका इनाम',
		friendDiscount: 'दोस्त की छूट',
		getCode: 'अपना रेफरल कोड पाएं',
		emailPlaceholder: 'अपना ईमेल दर्ज करें',
		invalidEmail: 'कृपया वैध ईमेल दर्ज करें',
		getCodeBtn: 'कोड पाएं',
		successTitle: 'आपका रेफरल कोड तैयार है!',
		successDesc: 'अपने यूनिक रेफरल कोड और निर्देशों के लिए अपना ईमेल देखें।',
		terms: '* आपके दोस्त की पहली बुकिंग पूरी होने के बाद इनाम लागू होते हैं। रेफरल पर कोई सीमा नहीं!',
	},
	newsletter: {
		title: 'विशेष ऑफर पाएं',
		subtitle: 'विशेष डील और पार्टी टिप्स के लिए हमारे न्यूज़लेटर की सदस्यता लें!',
		placeholder: 'अपना ईमेल पता दर्ज करें',
		subscribe: 'सदस्यता लें',
		invalidEmail: 'कृपया वैध ईमेल पता दर्ज करें',
		success: 'सदस्यता के लिए धन्यवाद! विशेष ऑफर के लिए अपना इनबॉक्स देखें।',
		error: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
		privacy: 'हम आपकी गोपनीयता का सम्मान करते हैं। कभी भी अनसब्सक्राइब करें।',
		benefit1: 'विशेष छूट',
		benefit2: 'पार्टी प्लानिंग टिप्स',
		benefit3: 'नए मेन्यू अपडेट',
	},
	myBooking: {
		title: 'मेरी बुकिंग देखें',
		subtitle: 'बुकिंग के समय इस्तेमाल किया गया ईमेल या फोन नंबर दर्ज करें',
		emailPlaceholder: 'अपना ईमेल पता दर्ज करें',
		phonePlaceholder: 'अपना फोन नंबर दर्ज करें',
		search: 'बुकिंग खोजें',
		searching: 'खोज रहे हैं...',
		results: 'परिणाम',
		noResults: 'कोई बुकिंग नहीं मिली',
		error: 'खोज विफल, कृपया पुनः प्रयास करें',
		bookingId: 'बुकिंग आईडी',
		needHelp: 'मदद चाहिए?',
		contactUs: 'यदि कोई प्रश्न हो, तो हमसे संपर्क करें',
		pendingNote: 'पुष्टि के लिए हम 2 घंटे के भीतर संपर्क करेंगे',
		confirmedNote: 'आपसे मिलने का इंतज़ार! शेफ 30 मिनट पहले पहुंचेगा',
	},
	faq: {
		title: 'सामान्य प्रश्न',
		subtitle: 'वह सब कुछ जो आपको जानना चाहिए',
		q1: 'आप किन क्षेत्रों में सेवा देते हैं?',
		a1: 'हम वर्तमान में कैलिफ़ोर्निया, टेक्सास और फ़्लोरिडा में सेवा देते हैं। कृपया सत्यापित करने के लिए हमसे संपर्क करें कि हम आपके विशिष्ट स्थान को कवर करते हैं।',
		q2: 'आप कितने मेहमानों को समायोजित कर सकते हैं?',
		a2: 'हमें न्यूनतम 10 मेहमानों की आवश्यकता है और 50 तक समायोजित कर सकते हैं। बड़े इवेंट के लिए, विशेष व्यवस्था के लिए हमसे संपर्क करें।',
		q3: 'मुझे क्या प्रदान करना होगा?',
		a3: 'आपको केवल जगह और अपने मेहमान प्रदान करने हैं! हम सभी उपकरण, सामग्री, बर्तन लाते हैं और सभी सेटअप और सफाई संभालते हैं।',
		q4: 'मुझे कितने समय पहले बुक करना चाहिए?',
		a4: 'हम सप्ताह के दिनों के इवेंट के लिए कम से कम 2 सप्ताह पहले और सप्ताहांत के लिए 3-4 सप्ताह पहले बुकिंग की सलाह देते हैं। लोकप्रिय तारीखें जल्दी बुक हो जाती हैं!',
		q5: 'क्या आप आहार प्रतिबंधों को समायोजित कर सकते हैं?',
		a5: 'हां! हम शाकाहारी विकल्प प्रदान करते हैं और अधिकांश आहार प्रतिबंधों को समायोजित कर सकते हैं। कृपया बुकिंग के समय हमें बताएं।',
		q6: 'आपकी रद्दीकरण नीति क्या है?',
		a6: 'इवेंट से 7+ दिन पहले रद्द करने पर पूर्ण रिफंड। 3-6 दिन की सूचना पर 50% रिफंड। 3 दिन से कम की सूचना पर कोई रिफंड नहीं।',
	},
	contact: {
		title: 'संपर्क करें',
		subtitle: 'संपर्क में रहें',
		phone: 'फोन',
		email: 'ईमेल',
		hours: 'व्यावसायिक घंटे',
		address: 'सेवा क्षेत्र',
	},
	footer: {
		description: 'आपके घर पर प्रामाणिक हिबाची अनुभव लाना',
		quickLinks: 'त्वरित लिंक',
		contact: 'संपर्क',
		followUs: 'हमें फॉलो करें',
		copyright: '© 2024 Happy Hibachi. सर्वाधिकार सुरक्षित।',
		allRightsReserved: 'सर्वाधिकार सुरक्षित।',
		privacyPolicy: 'गोपनीयता नीति',
		termsOfService: 'सेवा की शर्तें',
	},
	menuSelection: {
		title: 'अपना डिश प्रकार चुनें',
		subtitle: 'सभी भोजन में स्टीम्ड राइस, हिबाची सब्ज़ियां और सिग्नेचर सॉस शामिल हैं',
		regular: {
			title: 'रेगुलर',
			proteins: 'प्रति व्यक्ति 2 प्रोटीन',
			service: 'शो शामिल, 90 मिनट सेवा',
		},
		premium: {
			title: 'प्रीमियम',
			proteins: '2 प्रीमियम प्रोटीन: फ़िलेट मिग्नॉन, लॉबस्टर, स्कैलप्स',
			service: 'शो शामिल, 120 मिनट सेवा',
		},
		catering: {
			title: 'बड़ा समारोह',
			note: '50+ मेहमान बुफे स्टाइल',
			proteins: 'प्रति व्यक्ति 2 प्रोटीन',
			service: 'शो शामिल, 3-4 घंटे सेवा',
		},
		intimate: {
			title: 'छोटी पार्टी',
			note: '5-7 मेहमान',
			includes: 'सलाद, ग्योज़ा, एडामामे, नूडल्स + मिश्रित प्रोटीन',
			substitution: 'समान मूल्य के प्रोटीन बदले जा सकते हैं',
		},
	},
	form: {
		name: 'पूरा नाम',
		namePlaceholder: 'अपना पूरा नाम दर्ज करें',
		email: 'ईमेल पता',
		emailPlaceholder: 'आपका ईमेल दर्ज करें',
		phone: 'फोन नंबर',
		phonePlaceholder: 'फोन नंबर दर्ज करें',
		date: 'इवेंट की तारीख',
		time: 'पसंदीदा समय',
		guests: 'मेहमानों की संख्या',
		guestsHint: 'न्यूनतम 10 मेहमान',
		region: 'क्षेत्र चुनें',
		eventType: 'इवेंट प्रकार',
		message: 'अतिरिक्त संदेश',
		messagePlaceholder: 'हमें अपने इवेंट के बारे में बताएं...',
		selectOption: 'एक विकल्प चुनें',
		selectDate: 'तारीख चुनें',
		submit: 'जमा करें',
		submitting: 'जमा हो रहा है...',
		submitReservation: 'आरक्षण जमा करें',
		success: 'बुकिंग सबमिट हो गई!',
		successMessage: 'आपका बुकिंग अनुरोध प्राप्त हो गया है। पुष्टि के लिए हम 2 घंटे के भीतर आपसे संपर्क करेंगे।',
		weWillContact: 'विवरण की पुष्टि के लिए हम जल्द ही आपसे संपर्क करेंगे।',
		error: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
		required: 'आवश्यक',
		people: 'लोग',
		noPaymentRequired: '* अभी कोई भुगतान आवश्यक नहीं। पुष्टि के लिए हम आपसे संपर्क करेंगे।',
		invalidEmail: 'कृपया वैध ईमेल पता दर्ज करें',
		invalidPhone: 'कृपया वैध फोन नंबर दर्ज करें',
		eventTypes: {
			birthday: 'जन्मदिन पार्टी',
			anniversary: 'वर्षगांठ',
			graduation: 'स्नातक समारोह',
			corporate: 'कॉर्पोरेट इवेंट',
			holiday: 'छुट्टी पार्टी',
			other: 'अन्य',
		},
		referralSource: 'आपने हमारे बारे में कैसे सुना?',
		referral: {
			google: 'गूगल सर्च',
			friend: 'दोस्त का रेफरल',
			event: 'इवेंट में देखा',
			other: 'अन्य',
		},
		couponCode: 'कूपन कोड',
		couponPlaceholder: 'कूपन कोड दर्ज करें (वैकल्पिक)',
		applyCoupon: 'लागू करें',
	},
	estimate: {
		title: 'अपना निःशुल्क अनुमान पाएं',
		subtitle: 'हमें अपने इवेंट के बारे में बताएं और हम कस्टम कोट प्रदान करेंगे',
		benefits: {
			title: 'हमें क्यों चुनें?',
			professional: 'पेशेवर प्रशिक्षित शेफ',
			fresh: 'ताज़ी, उच्च गुणवत्ता वाली सामग्री',
			entertainment: 'लाइव कुकिंग एंटरटेनमेंट',
			cleanup: 'संपूर्ण सेटअप और सफाई',
			custom: 'अनुकूलन योग्य मेन्यू विकल्प',
		},
	},
	bookNow: {
		title: 'अपनी हिबाची पार्टी बुक करें',
		subtitle: 'अपनी तारीख आरक्षित करने के लिए नीचे फॉर्म भरें',
		selectRegion: 'पहले, अपना क्षेत्र चुनें',
		formTitle: 'इवेंट विवरण',
		pricing: 'मूल्य $45/व्यक्ति से',
		note: 'हम 2 घंटे के भीतर उपलब्धता की पुष्टि करेंगे',
	},
	notFound: {
		title: 'पेज नहीं मिला',
		description: 'आप जो पेज खोज रहे हैं वह मौजूद नहीं है।',
		backHome: 'होम पर वापस',
	},
	common: {
		learnMore: 'और जानें',
		viewAll: 'सभी देखें',
		loading: 'लोड हो रहा है...',
		close: 'बंद करें',
		backToHome: 'होम पर वापस',
		total: 'कुल',
		toBeConfirmed: 'पुष्टि होनी है',
		specialOffer: 'विशेष ऑफर',
		goTo: 'जाएं',
		previous: 'पिछला',
		next: 'अगला',
	},
	topBar: {
		textUs: 'मैसेज करें',
		email: 'ईमेल',
	},
	photoShare: {
		title: 'अपनी फ़ोटो शेयर करें',
		subtitle: 'अपना हिबाची अनुभव शेयर करें और अगले इवेंट पर $25 की छूट पाएं!',
		option1Title: 'इंस्टाग्राम पर पोस्ट करें',
		option1Desc: 'हमें टैग करें और #HappyHibachi का उपयोग करें',
		option2Title: 'सीधे अपलोड करें',
		option2Desc: 'हमारे साथ अपनी फ़ोटो शेयर करें',
		dropzone: 'यहां फ़ोटो ड्रैग और ड्रॉप करें या ब्राउज़ करने के लिए क्लिक करें',
		maxFiles: '5 फ़ोटो तक',
		instagramPlaceholder: 'आपका इंस्टाग्राम हैंडल (वैकल्पिक)',
		submit: 'फ़ोटो सबमिट करें',
		submitting: 'अपलोड हो रहा है...',
		successTitle: 'फ़ोटो सबमिट हो गई!',
		successDesc: 'शेयर करने के लिए धन्यवाद! $25 का क्रेडिट आपकी अगली बुकिंग में लागू होगा।',
		terms: '* फ़ोटो समीक्षा के बाद क्रेडिट लागू होगा। फ़ोटो हमारे सोशल मीडिया पर दिखाई जा सकती हैं।',
	},
	offer: {
		noTravel: 'कोई यात्रा शुल्क नहीं',
		within50: '50 मील के भीतर',
		noHidden: 'कोई छिपे हुए शुल्क नहीं',
		exclusive: 'विशेष छूट',
		freeSetup: 'मुफ्त टेबल और कुर्सियां',
		sunFri: 'रविवार से शुक्रवार स्पेशल!',
	},
	coupon: {
		minGuests: 'न्यूनतम {{count}} मेहमान आवश्यक',
		applied: 'कूपन लागू! छूट: {{discount}}',
		invalid: 'अमान्य कूपन कोड',
		checkFailed: 'सत्यापन विफल',
		under15: '15 से कम लोग',
		range15to25: '15-25 लोग',
		range25to35: '25-35 लोग',
		over35: '35+ लोग',
	},
	privacy: {
		title: 'गोपनीयता नीति',
		lastUpdated: 'अंतिम अपडेट: जनवरी 2026',
		section1: {
			title: '1. हम जो जानकारी एकत्र करते हैं',
			intro: 'जब आप Happy Hibachi सेवाओं का उपयोग करते हैं, तो हम एकत्र कर सकते हैं:',
			contact: 'संपर्क जानकारी',
			contactDesc: 'नाम, ईमेल पता, फोन नंबर',
			booking: 'बुकिंग विवरण',
			bookingDesc: 'इवेंट की तारीख, समय, स्थान, मेहमानों की संख्या',
			payment: 'भुगतान जानकारी',
			paymentDesc: 'तृतीय-पक्ष प्रदाताओं के माध्यम से सुरक्षित रूप से संसाधित',
			usage: 'उपयोग डेटा',
			usageDesc: 'आप हमारी वेबसाइट के साथ कैसे इंटरैक्ट करते हैं',
		},
		section2: {
			title: '2. हम आपकी जानकारी का उपयोग कैसे करते हैं',
			item1: 'आपकी बुकिंग को संसाधित और पुष्टि करना',
			item2: 'बुकिंग पुष्टिकरण और रिमाइंडर भेजना',
			item3: 'आपकी पूछताछ का जवाब देना',
			item4: 'हमारी सेवाओं में सुधार करना',
			item5: 'प्रचार ऑफर भेजना (आपकी सहमति से)',
		},
		section3: {
			title: '3. जानकारी साझा करना',
			intro: 'हम आपकी व्यक्तिगत जानकारी नहीं बेचते। हम जानकारी साझा कर सकते हैं:',
			item1: 'सेवा प्रदाताओं के साथ जो हमारे संचालन में सहायता करते हैं',
			item2: 'कानूनी अधिकारियों के साथ जब कानून द्वारा आवश्यक हो',
		},
		section4: {
			title: '4. डेटा सुरक्षा',
			desc: 'हम आपकी व्यक्तिगत जानकारी की सुरक्षा के लिए उचित सुरक्षा उपाय लागू करते हैं। हालांकि, कोई भी इंटरनेट ट्रांसमिशन 100% सुरक्षित नहीं है।',
		},
		section5: {
			title: '5. आपके अधिकार',
			intro: 'आपको अधिकार है:',
			item1: 'अपने व्यक्तिगत डेटा तक पहुंच',
			item2: 'गलत डेटा के सुधार का अनुरोध',
			item3: 'अपने डेटा को हटाने का अनुरोध',
			item4: 'मार्केटिंग संचार से ऑप्ट-आउट',
		},
		section6: {
			title: '6. कुकीज़',
			desc: 'हम आपके ब्राउज़िंग अनुभव को बेहतर बनाने और साइट ट्रैफ़िक का विश्लेषण करने के लिए कुकीज़ का उपयोग करते हैं। आप अपने ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ को नियंत्रित कर सकते हैं।',
		},
		section7: {
			title: '7. संपर्क करें',
			intro: 'गोपनीयता संबंधित प्रश्नों के लिए:',
		},
	},
	terms: {
		title: 'सेवा की शर्तें',
		lastUpdated: 'अंतिम अपडेट: जनवरी 2026',
		section1: {
			title: '1. सेवाएं',
			desc: 'Happy Hibachi मोबाइल हिबाची केटरिंग सेवाएं प्रदान करता है। हम प्रामाणिक हिबाची भोजन तैयार करने के लिए पेशेवर शेफ और उपकरण आपके स्थान पर लाते हैं।',
		},
		section2: {
			title: '2. बुकिंग और आरक्षण',
			minimum: 'न्यूनतम मेहमान',
			minimumDesc: 'न्यूनतम 10 मेहमान आवश्यक',
			confirmation: 'पुष्टि',
			confirmationDesc: 'हमारी टीम के संपर्क के बाद बुकिंग की पुष्टि होती है',
			deposit: 'जमा',
			depositDesc: 'आपकी तारीख सुरक्षित करने के लिए जमा राशि आवश्यक हो सकती है',
			finalCount: 'अंतिम गणना',
			finalCountDesc: 'इवेंट से 48 घंटे पहले मेहमानों की संख्या की पुष्टि होनी चाहिए',
		},
		section3: {
			title: '3. रद्दीकरण नीति',
			sevenDays: '7+ दिन की सूचना',
			sevenDaysDesc: 'जमा राशि का पूर्ण रिफंड',
			threeSixDays: '3-6 दिन की सूचना',
			threeSixDaysDesc: 'जमा राशि का 50% वापसी',
			lessThanThree: '3 दिन से कम',
			lessThanThreeDesc: 'जमा राशि वापस नहीं होगी',
			weather: 'मौसम',
			weatherDesc: 'खराब मौसम के लिए बिना शुल्क के पुनर्निर्धारण',
		},
		section4: {
			title: '4. ग्राहक की जिम्मेदारियां',
			intro: 'ग्राहकों को प्रदान करना होगा:',
			item1: 'खाना पकाने के लिए पर्याप्त बाहरी जगह (न्यूनतम 10x10 फीट)',
			item2: 'बिजली तक पहुंच (50 फीट के भीतर मानक आउटलेट)',
			item3: 'मेहमानों के लिए टेबल और बैठने की व्यवस्था',
			item4: 'आवश्यकता होने पर मौसम से सुरक्षा (टेंट, गैज़ेबो, आदि)',
		},
		section5: {
			title: '5. खाद्य सुरक्षा और एलर्जी',
			desc: 'कृपया बुकिंग के समय किसी भी खाद्य एलर्जी या आहार प्रतिबंधों के बारे में हमें सूचित करें। हम सावधानी बरतते हैं, लेकिन हिबाची कुकिंग की प्रकृति के कारण पूर्णतः एलर्जी-मुक्त वातावरण की गारंटी नहीं दे सकते।',
		},
		section6: {
			title: '6. देयता',
			desc: 'Happy Hibachi के पास देयता बीमा है। हालांकि, ग्राहक अपने मेहमानों और संपत्ति के लिए जिम्मेदार हैं। मेहमानों के व्यवहार या पूर्व-मौजूद संपत्ति स्थितियों से होने वाली दुर्घटनाओं के लिए हम उत्तरदायी नहीं हैं।',
		},
		section7: {
			title: '7. सेवा क्षेत्र',
			intro: 'हम वर्तमान में सेवा देते हैं:',
			california: 'कैलिफ़ोर्निया (लॉस एंजिल्स, सैन डिएगो, सैन फ्रांसिस्को और आसपास के क्षेत्र)',
			texas: 'टेक्सास (ह्यूस्टन, डलास, ऑस्टिन, सैन एंटोनियो और आसपास के क्षेत्र)',
			florida: 'फ़्लोरिडा (मियामी, फोर्ट लॉडरडेल और आसपास के क्षेत्र)',
			travelFee: 'हमारे मानक सेवा क्षेत्र से बाहर के स्थानों के लिए यात्रा शुल्क लागू हो सकता है।',
		},
		section8: {
			title: '8. शर्तों में परिवर्तन',
			desc: 'हम किसी भी समय इन शर्तों को संशोधित करने का अधिकार रखते हैं। हमारी सेवाओं का निरंतर उपयोग अपडेटेड शर्तों की स्वीकृति माना जाएगा।',
		},
		section9: {
			title: '9. संपर्क',
			intro: 'इन शर्तों के बारे में प्रश्न:',
		},
	},
	status: {
		pending: 'लंबित',
		confirmed: 'पुष्टि',
		completed: 'पूर्ण',
		cancelled: 'रद्द',
	},
	timeSlot: {
		afternoon: 'दोपहर',
		evening: 'शाम',
		night: 'रात',
	},
	admin: {
		login: {
			title: 'एडमिन लॉगिन',
			subtitle: 'जारी रखने के लिए पासवर्ड दर्ज करें',
			password: 'पासवर्ड',
			loginButton: 'लॉगिन',
			loggingIn: 'लॉगिन हो रहा है...',
			invalidPassword: 'अमान्य पासवर्ड',
			loginFailed: 'लॉगिन विफल',
			contactHelp: 'मदद के लिए संपर्क करें',
		},
		dashboard: {
			title: 'एडमिन डैशबोर्ड',
			logout: 'लॉगआउट',
		},
		stats: {
			totalBookings: 'कुल',
			pending: 'लंबित',
			confirmed: 'पुष्टि',
			completed: 'पूर्ण',
			cancelled: 'रद्द',
			totalGuests: 'कुल मेहमान',
		},
		tabs: {
			all: 'सभी',
			pending: 'लंबित',
			confirmed: 'पुष्टि',
			completed: 'पूर्ण',
			cancelled: 'रद्द',
		},
		booking: {
			noBookings: 'कोई बुकिंग नहीं',
			noBookingsHint: 'बुकिंग यहां दिखाई देगी',
			guests: 'मेहमान',
			booking: 'बुकिंग',
			estimate: 'अनुमान',
			contactInfo: 'संपर्क जानकारी',
			eventDetails: 'इवेंट विवरण',
			date: 'तारीख',
			time: 'समय',
			notSpecified: 'निर्दिष्ट नहीं',
			region: 'क्षेत्र',
			additionalNotes: 'अतिरिक्त नोट्स',
			updateStatus: 'स्थिति अपडेट करें',
			emailCustomer: 'ग्राहक को ईमेल करें',
			callCustomer: 'ग्राहक को कॉल करें',
		},
	},
};

export default hi;

